import React, { FC } from "react";

import { Section } from "@/components/Section";
import { IConsultantProfile } from "@/data/consultant-profiles";

import { LevelWidget, ProgressWidget } from "./components";

interface IConsultantProfileCompletenessWidgetProps {
  profile: IConsultantProfile;
  onUpdate: (profile: IConsultantProfile) => void;
}

export const ConsultantProfileCompletenessWidget: FC<IConsultantProfileCompletenessWidgetProps> = ({
  profile,
  onUpdate,
}) => {
  const isPrivateProfile = !profile.companyRole;
  return (
    <Section background="background-card" borderRadius>
      <LevelWidget role="top" {...profile.completeness} consultantProfileId={profile.id} />
      <ProgressWidget
        isPrivateProfile={isPrivateProfile}
        role="bottom"
        consultantProfileId={profile.id}
        completed={profile.completeness.completed}
        onUpdate={onUpdate}
      />
    </Section>
  );
};
